(function (angular) {
	'use strict';

	angular
		.module( 'settingsModule', [
			'apiModule',
			'confirmationModalModule',
			'coreModule',
			'fileUploadModule',
			'formValidationModule',
			'futureEarningsChartModule',
			'planModule',
			'serviceLevelModule',
			'ui.mask'
		])
		.value('globalConfig', globalConfig);
})(window.angular);